import wsDialog from './wsDialog'
import wsLoading from './wsLoading'
import wsMessage from './wsMessage'
// import wsHistory from './wsHistory'
// import wsSelect from './wsSelect'
// import wsNumberInput from './wsNumberInput'
import wsToast from './wsToast'
// import drawPlant from './drawplant'
// import wsTurntable from './wsTurntable'
// import wsDialogTransparent from './wsDialogTransparent'
// import wsSquareDraw from './wsSquareDraw'
const components = { 
    wsDialog:{
        type: 'component',
        value:wsDialog
    },
    // wsDialogTransparent:{
    //     type: 'component',
    //     value:wsDialogTransparent
    // },
    // wsHistory:{
    //     type: 'component',
    //     value:wsHistory
    // },
    // wsSelect:{
    //     type: 'component',
    //     value:wsSelect
    // },
    // wsNumberInput:{
    //     type: 'component',
    //     value:wsNumberInput
    // },
    // drawPlant:{
    //     type: 'component',
    //     value:drawPlant
    // },
    // wsTurntable:{
    //     type: 'component',
    //     value:wsTurntable
    // },
    // wsSquareDraw:{
    //     type: 'component',
    //     value:wsSquareDraw
    // },
    wsLoading:{
        type: 'directive',
        value:wsLoading
    },
    wsMessage:{
        type: 'directive',
        value:wsMessage
    },
    wsToast:{
        type: 'directive',
        value:wsToast
    },
   
};
const install = (Vue, pluginOptions = {}) => { // eslint-disable-line
    Object.keys(components).forEach((key) => {
        Vue.component(key, components[key].value);
        if(components[key].type === 'directive'){
            Vue.use(components[key].value)
        } 
    });
};
export default install;


// WEBPACK FOOTER //
// ./src/components/index.js